import footerSettingsApi from "../api/footer-settings-api";

// The endpoint returns FooterSettingsBean directly (Programs-style REST), not
// the older { status, responseMsgTh } envelope.
const get = async () => {
    try {
        return await footerSettingsApi.get();
    } catch (err) {
        console.error(err);
        throw err;
    }
};

const save = async (bean) => {
    try {
        return await footerSettingsApi.save(bean);
    } catch (err) {
        console.error(err);
        throw err;
    }
};

const footerSettingsService = {
    get,
    save,
};

export default footerSettingsService;
